module.exports = __webpack_public_path__ + "static/media/figure18.7445b377.png";